module.exports = {
  //baseUrl: "http://192.168.1.119:58080/api"
  //baseUrl: "http://176.107.133.68:8080/api"
  baseUrl: "http://192.168.8.27:8080/api"
  //baseUrl: "http://192.168.1.146:8080/api"
};
